module.exports = __webpack_public_path__ + "imgs/doctors-icon.892ec4f58964982e9972c64265ea7464.svg";